import { Container, AppIcon, AppName, LogoLink } from './styles';

const Header = () => {
    return (
        <Container>
            <LogoLink href="/">
                <AppIcon src="/assets/icon.png" alt="MoveStack" />
                <AppName>MoveStack</AppName>
            </LogoLink>
        </Container>
    );
}

export default Header;
